module.exports = __webpack_public_path__ + "static/media/wbtc.eafc06b4.svg";